import { useQuery } from 'react-query'
import { useChosenCompany, useUser } from '../../../../context/UserProvider'
import { fetchTollTransactionDetails } from '../../../../api/newApi'
import { useParams, useSearchParams } from 'react-router-dom'
import TollReportAccountDetailsTable from '../components/TollTables/TollReportAccountDetailsTable'
import { ExcelExportButton } from '../components/ExcelExporter'
import { excelTollReportAccountDetailsColumns } from '../components/TollTables/excelUtils'
import type { TollReportAccountDetails as TollAccountDetails } from '../../../../types'

const TollReportAccountDetails = () => {
  const { date, account } = useParams()
  const [searchParams] = useSearchParams()
  const regNo = searchParams.get('regNo') || ''
  const company = useChosenCompany()
  const companyId = company?.id
  const contactId = useUser()?.user?.id

  const [year, month] = date ? date.split('-') : ['', '']

  const { data: response, isLoading } = useQuery(
    ['tollReportAccountDetails', companyId, year, month, account, contactId],
    () =>
      fetchTollTransactionDetails({
        companyId,
        contactId,
        accountNo: account,
        year,
        month,
      }),
    { enabled: !!companyId && !!contactId && !!year && !!month && !!account },
  )

  //@ts-expect-error axios type issue
  const data = (response?.items && Array.isArray(response.items) ? response.items : []) as TollAccountDetails[]

  const columns = excelTollReportAccountDetailsColumns()
  const config = {
    columns,
    filename: `Bom_Transaksjoner_${regNo}_${year}_${month}.xlsx`,
    sheetName: `Bom_Transaksjoner`,
  }

  const mappedExcelData = data.map((item) => ({
    ...item,
    regNo,
    transactionDate: item.transactionDate,
    transactionTime: item.transactionTime,
  }))

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col md:flex-row md:items-center gap-2 md:justify-between">
        <div className="flex flex-row justify-between ">
          <div className="flex flex-col md:items-center md:flex-row gap-2">
            <span className="text-xl font-medium text-primaryText">Bomrapport</span>
            <span className=" hidden md:block text-lg text-secondaryText">/</span>
            <span className="text-lg text-secondaryText">
              {year}-{month}
            </span>
          </div>
          <div className="md:hidden">
            <ExcelExportButton data={mappedExcelData} config={config} />
          </div>
        </div>
        <div className="hidden md:block">
          <ExcelExportButton data={mappedExcelData} config={config} />
        </div>
      </div>
      <TollReportAccountDetailsTable isLoading={isLoading} data={data} />
    </div>
  )
}

export default TollReportAccountDetails
